<template>
  <div class="contents-wrapper">
    <div class="contents-header">
      <div class="nav">
        <router-link to="/"><img :src="scroll_event_homeImage" /></router-link>
      </div>
    </div>
    <div class="contents-body">
      <div class="portfolio-top" />
      <div class="title">
        <h1 id="title">Taste of Book</h1>
        <p id="role">UX/UI/GUI design, Branding<br />2019</p>
      </div>

      <div class="desc">
        <p id="desc">
          <b>Description</b><br />'책의 문장을 담는 그릇'이란 콘셉트로, 인상깊은
          책의 구절을 사진으로 찍으면 텍스트로 변환되어 문장을 수집할 수 있다.
        </p>
        <p id="name">
          <b>Planning:</b> Yuri Ahn, Jeongwoo Ahn, Yoonhong Min<br /><b
            >UX Design:</b
          >
          Yuri Ahn, Jeongwoo Ahn, Yoonhong Min<br /><b>UI/GUI Design:</b> Yuri
          Ahn<br /><b>Front-end programming:</b> Yoonhong Min, Jeongwoo Ahn<br /><b
            >Back-end programming:</b
          >
          Jeongwoo Ahn, Yoonhong Min
        </p>
      </div>
      <div class="img-contents">
        <img src="/images/portfolios/taste_of_book/icon_symbol.svg" />
        <img src="/images/portfolios/taste_of_book/icon.svg" />
        <img src="/images/portfolios/taste_of_book/loading.gif" />
        <img
          class="mini"
          src="/images/portfolios/taste_of_book/wireframe.png"
        />
        <img src="/images/portfolios/taste_of_book/bt_framer.gif" />
        <img src="/images/portfolios/taste_of_book/01.png" />
        <img src="/images/portfolios/taste_of_book/02.png" />
        <img src="/images/portfolios/taste_of_book/03.png" />
      </div>
    </div>
    <div class="move-btn">
      <span class="prev" @click="move('bium')">
        <img src="/images/chevron-left.svg" />Previous
      </span>
      <span class="next" @click="move('milk-ui')">
        Next<img src="/images/chevron-right.svg" />
      </span>
    </div>
    <div class="contents-footer">
      <span class="name">
        <img src="/images/home_full_name.svg" />
      </span>
      <span class="copyright">
        <p>2021 ⓒ ahnyuri</p>
      </span>
    </div>
  </div>
</template>

<script>
import { ScrollEventMixin } from "@/mixins/ScrollEventMixin";
export default {
  name: "DetailTasteOfBook",
  mixins: [ScrollEventMixin],
  data() {
    return {};
  },
  methods: {
    move(url) {
      this.$router.push(`/detail/${url}`);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/views/HomeHeader.scss";
@import "@/views/HomeFooter.scss";
.contents-body {
  // display: flex;
  // outline: 1px red dashed;
  // height: 1500px;
}
.contents-wrapper {
  overflow-x: hidden;
}
.portfolio-top {
  width: 100%;
  height: 800px;
  margin: 0 auto;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
  background-image: url("/images/portfolios/taste_of_book/top.png");
}

.title {
  float: left;
  margin-left: 10%;
  display: inline-block;
  margin-bottom: 0;
}

.title h1 {
  color: #303133;
  margin-top: 100px;
}
.title p {
  font-size: 13px;
  line-height: 20px;
  color: #606266;
  margin-top: -5px;
}
.desc {
  float: right;
  margin-right: 10%;
  margin-top: 85px;
  margin-bottom: 100px;
  width: 550px;
  font-size: 16px;
  line-height: 26px;
  color: #606266;
  display: inline-block;
}

.img-contents img {
  margin-top: -5px;
  width: 100%;
  margin-left: 0;
  margin-right: 0;
}

.img-contents img.mini {
  width: 80%;
  margin-left: 10%;
  margin-right: 10%;
  margin-top: 50px;
}

.move-btn {
  cursor: pointer;
  width: 100%;
  display: inline-block;
}
.move-btn a {
  cursor: pointer;
}
.move-btn > .prev {
  color: #606266;
  margin-left: 5%;
  margin-top: 100px;
  margin-bottom: 100px;
  float: left;
}
.prev:hover {
  color: #303133;
}
.move-btn > .next {
  color: #606266;
  margin-right: 5%;
  margin-top: 100px;
  margin-bottom: 100px;
  float: right;
}
.next:hover {
  color: #303133;
}
@import "@/views/DetailZMedia.scss";
</style>
